import React from 'react'
import PropTypes from 'prop-types'
import compose, { getCityName, getNationalityName } from '../../utils/functions'
import { APPOINTMENT_PREFERENCE_API, ROLE, ROLE_CAST } from '../../constants'
import SearchSelect from 'react-select'
import { getValueFromStorage } from '../../utils'
import { v4 as uuidv4 } from 'uuid'

// Apollo client
import { withApollo } from '@apollo/client/react/hoc'
import { addPatient, getPatientsNames } from '../../graphql/patient'
import { addAppointmentFromEntity } from '../../graphql/appointment'
import { generateUploadSignedURL } from '../../graphql/uploadFiles'

// Date managment
import MomentUtils from '@date-io/moment'
import { MuiPickersUtilsProvider } from 'material-ui-pickers'
import moment from 'moment'

// Design imports
import {
    Button,
    Divider,
    FormControl,
    FormControlLabel,
    Grid,
    Paper,
    Radio,
    RadioGroup,
    Step,
    StepButton,
    StepContent,
    StepLabel,
    Stepper,
    TextField,
    Typography,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import SocialWorkerIcon from '@material-ui/icons/SupervisorAccount'
import ScheduleIcon from '@material-ui/icons/WatchLater'
import NotesIcon from '@material-ui/icons/Notes'
import SendIcon from '@material-ui/icons/Send'
import PersonAddIcon from '@material-ui/icons/PersonAdd'
import { getLoggedSocialWorker } from '../../graphql/social_workers'
import NewPatient from '../molecule/NewPatient/NewPatient'
import TextLabel from '../atom/TextLabel'

// Constants
const PATIENT_STEP = 0
const SCHEDULE_STEP = 1
const OBSERVATIONS_STEP = 2
const SUMMARY_STEP = 3

function getSteps(needAppointmentSheet = false) {
    const steps = [
        'Seleccioni un pacient',
        "Seleccioni preferencia d'horaris",
        'Observacions (Opcional)',
        'Resum i confirmació de la cita',
    ]
    if (needAppointmentSheet) {
        // Insertar el paso después de Observacions
        steps.splice(3, 0, 'Fulla de derivació del pacient')
    }
    return steps
}

class VisitRequestStepper extends React.Component {
    constructor(props) {
        super(props)

        this.newPatientComponentRef = React.createRef()

        this.state = {
            patients: [],
            newPatient: null,
            activeStep: 0,
            completedSteps: [],
            selectedPatientId: null,
            showNewPatient: false,
            favoriteTimeValue: 'morning',
            observations: '',
            socialWorkerId: null,
            selectedPatientError: false,
            // Estado para el archivo adjunto
            appointmentSheetFile: null,
            appointmentSheetError: false,
        }
    }

    parseData = (patientsFromAPI) => {
        var patients = []

        patientsFromAPI.forEach((patient) => {
            patients.push({
                value: patient.id,
                label: patient.name?.toUpperCase() + ' ' + patient.lastName?.toUpperCase(),
            })
        })

        this.setState({ patients: patients })
    }

    componentDidMount() {
        if (this.props.selectedPatient !== null) {
            const selectedPatient = this.props.selectedPatient
            const patients = [
                { value: selectedPatient.id, label: selectedPatient.name + ' ' + selectedPatient.lastName },
            ]

            this.setState({
                patients,
                selectedPatientId: selectedPatient.id,
            })
        }

        const role = getValueFromStorage(ROLE)
        if (role === ROLE_CAST.TS) {
            this.props.client.query(getLoggedSocialWorker()).then((result) => {
                const socialWorker = result.data.loggedSocialWorker
                if (socialWorker !== null && socialWorker !== undefined) {
                    this.setState({ socialWorkerId: socialWorker.id })
                }
            })
        }
    }

    fetchPatients = (search = undefined) => {
        this.props.client
            .query(getPatientsNames(search))
            .then((result) => this.parseData(result.data.allPatients.patients))
    }

    validateData = () => {
        var dataIsValid = true

        var errors = {
            selectedPatientError: false,
        }

        if (!this.state.showNewPatient && this.state.selectedPatientId === null) {
            errors.selectedPatientError = true
            dataIsValid = false
        }

        this.setState(errors)
        return dataIsValid
    }

    sendAddAppointmentQuery = (id, appointmentSheet = null) => {
        var preference = ''
        switch (this.state.favoriteTimeValue) {
            case 'morning':
                preference = APPOINTMENT_PREFERENCE_API.MORNING
                break
            case 'afternoon':
                preference = APPOINTMENT_PREFERENCE_API.AFTERNOON
                break
            default:
                preference = APPOINTMENT_PREFERENCE_API.ANYTIME
        }

        const mutation = addAppointmentFromEntity(
            preference,
            this.state.observations,
            id,
            this.state.socialWorkerId,
            appointmentSheet,
        )

        this.props.client.mutate(mutation).then((result) => {
            this.props.handleConfirm()
        })
    }

    handleConfirm = async () => {
        const { needAppointmentSheet } = this.props
        const { appointmentSheetFile } = this.state

        // Validación extra si se requiere adjuntar fichero
        if (needAppointmentSheet) {
            if (!appointmentSheetFile) {
                this.setState({ appointmentSheetError: true, activeStep: 3 })
                return
            }
        }

        if (this.validateData()) {
            // Si hay que subir el archivo, primero pedimos la signedUrl y subimos el archivo a S3
            let fileToUpload = appointmentSheetFile
            let uniqueFileName = null
            if (needAppointmentSheet && appointmentSheetFile) {
                // Generar nombre único con uuid y mantener la extensión
                const ext = appointmentSheetFile.name.split('.').pop()
                uniqueFileName = `${uuidv4()}.${ext}`
                // Creamos un nuevo objeto File con el nombre único
                try {
                    fileToUpload = new File([appointmentSheetFile], uniqueFileName, { type: appointmentSheetFile.type })
                } catch (e) {
                    // Si falla, usamos el original
                    fileToUpload = appointmentSheetFile
                }
                try {
                    // 1. Pedir signed URL
                    const { type } = fileToUpload
                    const mutation = generateUploadSignedURL(uniqueFileName, type)
                    const response = await this.props.client.mutate(mutation)
                    const signedUrl = response.data.generateUploadSignedURL

                    // 2. Subir el archivo a S3 usando fetch
                    const uploadRes = await fetch(signedUrl, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': type,
                        },
                        body: fileToUpload,
                    })
                    if (!uploadRes.ok) {
                        throw new Error('Error al subir el archivo a S3')
                    }
                } catch (err) {
                    this.setState({ appointmentSheetError: true })
                    alert('Error al subir el archivo: ' + err.message)
                    return
                }
            }

            const { showNewPatient, newPatient } = this.state

            if (showNewPatient) {
                const mutation = addPatient(
                    newPatient.name,
                    newPatient.lastName,
                    newPatient.birthdate.valueOf().toString(),
                    newPatient.email,
                    newPatient.phone,
                    null,
                    newPatient.idNumber,
                    newPatient.nationality,
                    newPatient.address,
                    newPatient.city,
                    newPatient.postalCode,
                )

                this.props.client.mutate(mutation).then((result) => {
                    this.sendAddAppointmentQuery(
                        result.data.addPatient.id,
                        needAppointmentSheet ? uniqueFileName : null,
                    )
                })
            } else {
                this.sendAddAppointmentQuery(
                    this.state.selectedPatientId.value,
                    needAppointmentSheet ? uniqueFileName : null,
                )
            }
        } else {
            this.setState({ activeStep: PATIENT_STEP })
        }
    }

    handleNext = () => {
        const { activeStep, completedSteps, showNewPatient } = this.state

        if (
            activeStep + 1 === SUMMARY_STEP &&
            !(this.state.completedSteps.includes(0) && this.state.completedSteps.includes(1))
        ) {
            return
        }

        if (activeStep === PATIENT_STEP && showNewPatient) {
            if (!this.newPatientComponentRef.current.validateData()) return
            else
                this.setState({
                    newPatient: { ...this.newPatientComponentRef.current.state.patient },
                })
        }

        const newCompletedSteps = completedSteps
        if (completedSteps.indexOf(activeStep) < 0) {
            newCompletedSteps.push(activeStep)
        }

        this.setState((state) => ({
            activeStep: state.activeStep + 1,
            completedSteps: newCompletedSteps,
        }))
    }

    handleBack = () => {
        const { activeStep, completedSteps } = this.state

        const newCompletedSteps = completedSteps
        const index = completedSteps.indexOf(activeStep)
        if (index >= 0) {
            newCompletedSteps.splice(index, 1)
        }

        this.setState((state) => ({
            activeStep: state.activeStep - 1,
            completedSteps: newCompletedSteps,
        }))
    }

    handleStep = (step) => () => {
        if (this.state.activeStep === PATIENT_STEP && this.state.showNewPatient) {
            if (!this.newPatientComponentRef.current.validateData()) return
            else
                this.setState({
                    newPatient: { ...this.newPatientComponentRef.current.state.patient },
                })
        }

        if (
            step === SUMMARY_STEP &&
            !(this.state.completedSteps.includes(0) && this.state.completedSteps.includes(1))
        ) {
            return
        }

        this.setState({
            activeStep: step,
        })
    }

    handlePatientToggleButton = (showNewPatient) => {
        this.setState({ showNewPatient: showNewPatient })
    }

    handlePatientSelection = (name) => (value) => {
        this.setState({ selectedPatientId: value })
    }

    onSearchInputChange = (name) => (value) => {
        if (value.length >= 2) {
            this.fetchPatients(value)
        }
    }

    handlePreferredScheduleSelected = () => (event) => {
        this.setState({ favoriteTimeValue: event.target.value })
    }

    handleObservationsChanges = () => (event) => {
        this.setState({ observations: event.target.value })
    }

    handleFileChange = (event) => {
        const file = event.target.files[0]
        if (
            file &&
            (file.type === 'application/pdf' ||
                file.type === 'application/msword' ||
                file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
        ) {
            this.setState({ appointmentSheetFile: file, appointmentSheetError: false })
        } else {
            this.setState({ appointmentSheetFile: null, appointmentSheetError: true })
        }
    }

    renderInfoStep = () => {
        const { classes } = this.props

        var patientContent = null
        if (this.state.showNewPatient) {
            patientContent = (
                <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
                    <Paper className={classes.paperRoot}>
                        <div className={classes.cardHeader}>
                            <div className={classes.cardTitleContainer}>
                                <PersonAddIcon color="primary" style={{ fontSize: 28 }} />
                                <Typography className={classes.title} variant="h6" color="primary">
                                    Nou pacient
                                </Typography>
                            </div>
                        </div>
                        <Divider />
                        <NewPatient
                            innerRef={this.newPatientComponentRef}
                            isUpdating={false}
                            isSocialWorker={true}
                            patient={this.state.newPatient}
                        />
                    </Paper>
                </MuiPickersUtilsProvider>
            )
        } else {
            patientContent = (
                <Paper className={classes.paperRoot}>
                    <div className={classes.cardHeader}>
                        <div className={classes.cardTitleContainer}>
                            <SocialWorkerIcon color="primary" style={{ fontSize: 28 }} />
                            <Typography className={classes.title} variant="h6" color="primary">
                                Selecciona un pacient existent:
                            </Typography>
                        </div>
                    </div>
                    <Divider />
                    <div className={classes.cardContainer}>
                        <FormControl fullWidth variant="outlined" className={classes.formControl}>
                            <SearchSelect
                                value={this.state.selectedPatientId}
                                onChange={this.handlePatientSelection()}
                                onInputChange={this.onSearchInputChange()}
                                options={this.state.patients}
                                placeholder={'Escriu dues lletres per començar la cerca'}
                                noOptionsMessage={() => "No s'ha trobat cap pacient"}
                                isClearable
                            />
                        </FormControl>
                    </div>
                </Paper>
            )
        }

        return (
            <Grid container spacing={16}>
                <Grid item xs={12} sm={12} md={12} lg={6}>
                    {patientContent}
                </Grid>
            </Grid>
        )
    }

    renderScheduleStep = () => {
        const { classes } = this.props

        return (
            <Grid container spacing={16}>
                <Grid item xs={12} sm={12} md={12} lg={6}>
                    <Paper className={classes.paperRoot}>
                        <div className={classes.cardHeader}>
                            <div className={classes.cardTitleContainer}>
                                <ScheduleIcon color="primary" style={{ fontSize: 28 }} />
                                <Typography className={classes.title} variant="h6" color="primary">
                                    Selecciona quin horari prefereix el pacient
                                </Typography>
                            </div>
                        </div>
                        <Divider />
                        <div className={classes.cardContainer}>
                            <FormControl component="fieldset" className={classes.formControl}>
                                <RadioGroup
                                    row
                                    aria-label="preferred-schedule"
                                    name="preferred-schedule"
                                    className={classes.group}
                                    value={this.state.favoriteTimeValue}
                                    onChange={this.handlePreferredScheduleSelected()}>
                                    <FormControlLabel
                                        className={classes.radioButton}
                                        value="morning"
                                        control={<Radio color="primary" />}
                                        label="Mati"
                                        labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        className={classes.radioButton}
                                        value="afternoon"
                                        control={<Radio color="primary" />}
                                        label="Tarda"
                                        labelPlacement="end"
                                    />
                                    <FormControlLabel
                                        className={classes.radioButton}
                                        value="none"
                                        control={<Radio color="primary" />}
                                        label="Indiferent"
                                        labelPlacement="end"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </div>
                    </Paper>
                </Grid>
            </Grid>
        )
    }

    renderObservationStep = () => {
        const { classes } = this.props

        return (
            <Grid container spacing={16}>
                <Grid item xs={12} sm={12} md={12} lg={6}>
                    <Paper className={classes.paperRoot}>
                        <div className={classes.cardHeader}>
                            <div className={classes.cardTitleContainer}>
                                <NotesIcon color="primary" style={{ fontSize: 28 }} />
                                <Typography className={classes.title} variant="h6" color="primary">
                                    Afegeix les observacions oportunes (Opcional)
                                </Typography>
                            </div>
                        </div>
                        <Divider />
                        <div className={classes.cardContainer}>
                            <TextField
                                fullWidth
                                id="appointment-observations"
                                label="Observacions"
                                multiline
                                rowsMax="4"
                                value={this.state.observations}
                                onChange={this.handleObservationsChanges('multiline')}
                                className={classes.textField}
                                helperText="Per exemple, dies de la setmana que no pot anar, si necessita algun tractament especial, si ha d'anar acompanyat, etc."
                                variant="outlined"
                            />
                        </div>
                    </Paper>
                </Grid>
            </Grid>
        )
    }

    renderAppointmentSheetStep = () => {
        const { classes } = this.props
        const { appointmentSheetFile, appointmentSheetError } = this.state
        return (
            <Grid container spacing={16}>
                <Grid item xs={12} sm={12} md={12} lg={6}>
                    <Paper className={classes.paperRoot}>
                        <div className={classes.cardHeader}>
                            <div className={classes.cardTitleContainer}>
                                <Typography className={classes.title} variant="h6" color="primary">
                                    Adjunti la fulla de derivació del pacient
                                </Typography>
                            </div>
                        </div>
                        <Divider />
                        <div className={classes.cardContainer}>
                            <input
                                accept=".pdf,.doc,.docx"
                                style={{ display: 'none' }}
                                id="appointment-sheet-upload"
                                type="file"
                                onChange={this.handleFileChange}
                            />
                            <label htmlFor="appointment-sheet-upload">
                                <Button variant="contained" color="primary" component="span">
                                    Seleccionar arxiu
                                </Button>
                            </label>
                            {appointmentSheetFile && (
                                <Typography variant="body2" style={{ marginTop: 8 }}>
                                    Fitxer seleccionat: {appointmentSheetFile.name}
                                </Typography>
                            )}
                            {appointmentSheetError && (
                                <Typography variant="body2" color="error" style={{ marginTop: 8 }}>
                                    Només es permeten arxius PDF o DOC/DOCX
                                </Typography>
                            )}
                        </div>
                    </Paper>
                </Grid>
            </Grid>
        )
    }

    renderSummaryStep = () => {
        const { classes } = this.props
        const { appointmentSheetFile } = this.state
        const { needAppointmentSheet } = this.props

        var patientData = null
        if (this.state.showNewPatient) {
            let patient = this.state.newPatient
            if (!patient) patientData = null
            else {
                patientData = (
                    <Grid item xs={12}>
                        <Grid container spacing={16}>
                            <TextLabel title={'Nom:'} value={patient.name} xs={12} sm={6} />
                            <TextLabel title={'Cognoms:'} value={patient.lastName} xs={12} sm={6} />
                            <TextLabel title={'DNI/NIE/Passaport:'} value={patient.idNumber} xs={12} sm={6} />
                            <TextLabel
                                title={'Nacionalitat:'}
                                value={getNationalityName(patient.nationality)}
                                xs={12}
                                sm={6}
                            />
                            <TextLabel
                                title={'Data de naixement:'}
                                value={patient.birthdate?.format('DD/MM/YYYY')}
                                xs={12}
                                sm={6}
                            />
                            <TextLabel title={'Telèfon:'} value={patient.phone} type={'phone'} xs={12} sm={6} />
                            <TextLabel
                                title={'Email del pacient:'}
                                value={patient.email}
                                type={'email'}
                                xs={12}
                                sm={6}
                            />
                            <TextLabel title={'Adreça:'} value={patient.address} xs={12} sm={6} />
                            <TextLabel title={'Municipi:'} value={getCityName(patient.city)} xs={12} sm={6} />
                            <TextLabel title={'Codi postal:'} value={patient.postalCode} xs={12} sm={6} />
                        </Grid>
                    </Grid>
                )
            }
        } else {
            const patientIndex = this.state.patients.findIndex((item) => {
                const selectedPatientId =
                    this.state.selectedPatientId !== null ? this.state.selectedPatientId.value : null
                return item.value === selectedPatientId
            })
            const patientName = patientIndex >= 0 ? this.state.patients[patientIndex].label : 'Cap pacient seleccionat'

            patientData = (
                <Grid item xs={12}>
                    <Typography className={classes.labelTitle} variant="subtitle2">
                        Pacient:
                    </Typography>
                    <Typography className={classes.label} variant="subtitle1">
                        {patientName}
                    </Typography>
                </Grid>
            )
        }

        var preferredTime = null
        switch (this.state.favoriteTimeValue) {
            case 'morning':
                preferredTime = 'Mati'
                break
            case 'afternoon':
                preferredTime = 'Tarda'
                break
            default:
                preferredTime = 'Indiferent'
        }

        return (
            <Grid container spacing={16}>
                <Grid item xs={12} sm={12} md={12} lg={6}>
                    <Paper className={classes.paperRoot}>
                        <div className={classes.cardHeader}>
                            <div className={classes.cardTitleContainer}>
                                <SendIcon color="primary" style={{ fontSize: 28 }} />
                                <Typography className={classes.title} variant="h6" color="primary">
                                    Revisi les dades i confirmi la petició d'hora
                                </Typography>
                            </div>
                        </div>
                        <Divider />
                        <div className={classes.cardContainer}>
                            <Grid container spacing={16}>
                                {patientData}
                                <Grid item xs={12}>
                                    <Typography className={classes.labelTitle} variant="subtitle2">
                                        Horari:
                                    </Typography>
                                    <Typography className={classes.label} variant="subtitle1">
                                        {preferredTime}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography className={classes.labelTitle} variant="subtitle2">
                                        Observacions:
                                    </Typography>
                                    <Typography className={classes.label} variant="subtitle1">
                                        {this.state.observations === '' ? 'Cap observació' : this.state.observations}
                                    </Typography>
                                </Grid>
                                {needAppointmentSheet && (
                                    <Grid item xs={12}>
                                        <Typography className={classes.labelTitle} variant="subtitle2">
                                            Fulla de derivació adjunta:
                                        </Typography>
                                        <Typography className={classes.label} variant="subtitle1">
                                            {appointmentSheetFile
                                                ? appointmentSheetFile.name
                                                : "No s'ha adjuntat cap fitxer"}
                                        </Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </div>
                    </Paper>
                </Grid>
            </Grid>
        )
    }

    renderStepContent = (index) => {
        const { needAppointmentSheet } = this.props
        // Si needAppointmentSheet está activo, el paso 3 es el de adjuntar archivo
        if (needAppointmentSheet) {
            switch (index) {
                case PATIENT_STEP:
                    return this.renderInfoStep()
                case SCHEDULE_STEP:
                    return this.renderScheduleStep()
                case OBSERVATIONS_STEP:
                    return this.renderObservationStep()
                case 3:
                    return this.renderAppointmentSheetStep()
                case 4:
                    return this.renderSummaryStep()
                default:
                    return null
            }
        } else {
            switch (index) {
                case PATIENT_STEP:
                    return this.renderInfoStep()
                case SCHEDULE_STEP:
                    return this.renderScheduleStep()
                case OBSERVATIONS_STEP:
                    return this.renderObservationStep()
                case SUMMARY_STEP:
                    return this.renderSummaryStep()
                default:
                    return null
            }
        }
    }

    renderNewPatientButton = (index) => {
        const { classes } = this.props

        if (index === PATIENT_STEP) {
            if (this.state.showNewPatient) {
                return (
                    <Button
                        variant="flat"
                        color="primary"
                        onClick={() => this.handlePatientToggleButton(false)}
                        className={classes.button}>
                        Seleccionar un pacient existent
                    </Button>
                )
            }

            return (
                <Button
                    variant="flat"
                    color="primary"
                    onClick={() => this.handlePatientToggleButton(true)}
                    className={classes.button}>
                    Donar d'alta un nou pacient
                </Button>
            )
        }
    }

    renderStep = (label, index) => {
        const { classes } = this.props
        const { activeStep, completedSteps } = this.state
        const { needAppointmentSheet } = this.props
        const steps = getSteps(needAppointmentSheet)

        const completed = completedSteps.indexOf(index) >= 0

        var stepLabel = <StepLabel completed={completed}>{label}</StepLabel>
        if (activeStep !== index) {
            stepLabel = (
                <StepButton onClick={this.handleStep(index)} completed={completed}>
                    {label}
                </StepButton>
            )
        }

        return (
            <Step key={label}>
                {stepLabel}
                <StepContent>
                    {this.renderStepContent(index)}
                    <div className={classes.actionsContainer}>
                        <div>
                            <Button disabled={activeStep === 0} onClick={this.handleBack} className={classes.button}>
                                Anterior
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    this.handleNext()
                                    if (activeStep === steps.length - 1) {
                                        this.handleConfirm()
                                    }
                                }}
                                className={classes.button}>
                                {activeStep === steps.length - 1 ? 'Confirmar' : 'Següent'}
                            </Button>
                            {this.renderNewPatientButton(index)}
                        </div>
                    </div>
                </StepContent>
            </Step>
        )
    }

    render() {
        const { classes } = this.props
        const { activeStep } = this.state
        const { needAppointmentSheet } = this.props
        const steps = getSteps(needAppointmentSheet)

        return (
            <div className={classes.root}>
                <Stepper
                    nonLinear
                    activeStep={activeStep}
                    orientation="vertical"
                    classes={{ root: classes.stepperRoot }}>
                    {steps.map((label, index) => this.renderStep(label, index))}
                </Stepper>
            </div>
        )
    }
}

const styles = (theme) => ({
    root: {
        width: '100%',
        //padding: '8px',
    },
    stepperRoot: {
        backgroundColor: '#FAFAFA',
        padding: theme.spacing.unit,
    },
    button: {
        marginTop: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    actionsContainer: {
        marginTop: theme.spacing.unit,
    },
    resetContainer: {
        padding: theme.spacing.unit * 3,
    },
    formControl: {
        //margin: theme.spacing.unit,
        /*marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,*/
        //maxWidth: 300,
    },
    stepContainer: {
        minHeight: 200,
        padding: theme.spacing.unit * 2,
        margin: '0px',
    },
    paperRoot: {
        /*height: '100%',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'flex-start'*/
    },
    cardHeader: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        padding: theme.spacing.unit * 3,
        justifyContent: 'space-between',
        maxHeight: '100px',
    },
    cardTitleContainer: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
    },
    cardContainer: {
        padding: theme.spacing.unit * 3,
    },
    title: {
        paddingLeft: '8px',
    },
    radioButton: {
        marginRight: '56px',
    },
    labelTitle: {
        fontWeight: 'bold',
        textTransform: 'uppercase',
        color: theme.palette.primary.light,
    },
    label: {
        fontWeight: 'normal',
    },
    textFieldWidth: {
        marginRight: theme.spacing.unit,
        minWidth: '200px',
    },
})

VisitRequestStepper.propTypes = {
    classes: PropTypes.object.isRequired,
    handleConfirm: PropTypes.func.isRequired,
    selectedPatient: PropTypes.object,
}

VisitRequestStepper.defaultProps = {
    selectedPatient: null,
}

export default compose(withApollo, withStyles(styles))(VisitRequestStepper)
